import BaseHTMLColumnStrategy from './BaseHTMLColumnStrategy'

export default function BSHtmlBaseBTStrategy() {}

BSHtmlBaseBTStrategy.prototype = new BaseHTMLColumnStrategy();

BSHtmlBaseBTStrategy.prototype.getLevelsNumber = function () {
    return 1;
};

BSHtmlBaseBTStrategy.prototype.getColspan = function () {
    return 1;
};

BSHtmlBaseBTStrategy.prototype.addFirstHeaderRowCells = function ( row, levelsNumber ) {
    // do nothing
};

BSHtmlBaseBTStrategy.prototype.addSecondHeaderRowCells = function ( row, levelsNumber ) {
    // do nothing
};

BSHtmlBaseBTStrategy.prototype.addColumnValueCells = function ( row ) {
    // abstract
};

BSHtmlBaseBTStrategy.prototype.addTimeColumnValueCells = function ( row ) {
    this.addTimeValueCell(row);
};

BSHtmlBaseBTStrategy.prototype.addMoneyColumnValueCells = function ( row ) {
    this.addMoneyValueCell(row);
};

BSHtmlBaseBTStrategy.prototype.createNonBillableCell = function ( levelsNumber ) {
    return ReportPreviewUtils.createCell(
            this.message( "report.billing_summary.billing_type.html" ) +
            "&nbsp; <span class='smallText'>" + this.message( "report.billing_summary.non_billable.html" ) +
            "</span>",
            "typeOfWork nonBillable", this.getColspan(), levelsNumber );
};

BSHtmlBaseBTStrategy.prototype.createBillableCell = function ( levelsNumber, typeClass ) {
    return ReportPreviewUtils.createCell( this.message( "report.billing_summary.billing_type.html" ),
                                          "typeOfWork " + typeClass, this.getColspan(), levelsNumber );
};



// WEBPACK FOOTER //
// ./web/js/reports/preview/html/billingsummary/BSHtmlBaseBTStrategy.js